<template>
  <div class="inpBox">
    <div class="detailsTitle">
      <h4>新增订单</h4>
      <div @click="back"><i class="fa fa-reply"></i></div>
  </div>
   <el-form :inline="true" ref="goodform" enctype="multipart/form-data" :model="goodform" :rules="rules"  class="demo-form-inline jiaoyan" label-width="110px" size="mini">
      <div class="addressBox">
        <h4 class="title">
          <span><i class="fa fa-envelope iconFont" aria-hidden="true"></i>收发货信息</span>
        </h4>
        <div>
            <el-form-item  class="is-required" label="发货单位:" prop="deliverCompany">
            <el-input  placeholder="请选择发货地址" class="disabled" maxlength="20" :readonly="true"  v-model="goodform.deliverCompany"></el-input>
          </el-form-item>
          <el-form-item    class="is-required" label="发货人:" prop="deliverPerson">
            <el-input  placeholder="请选择发货地址" class="disabled" maxlength="10" :readonly="true"  v-model="goodform.deliverPerson"></el-input>
          </el-form-item>
          <el-form-item label="发货人电话:" class="is-required" prop="deliverPhone">
            <el-input  placeholder="请选择发货地址" class="disabled" maxlength="11" :readonly="true"  type="tel" v-model="goodform.deliverPhone"></el-input>
          </el-form-item>
          <el-form-item  label="发货地址:" prop="deliverAddress" class="diqu1">
            <el-input  placeholder="请选择发货地址" class="disabled" maxlength="11" :readonly="true"  v-model="goodform.deliverAddress"></el-input>
          </el-form-item>
           <el-form-item >
              <el-button type="text"  @click="addxzdzFn(2)"><i class="fa fa-address-book-o iconFont" aria-hidden="true"></i>使用发货地址簿</el-button>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="收货单位:" prop="receivingCompany">
          <el-input  placeholder="请选择收货地址" class="disabled" maxlength="20" :readonly="true"  v-model="goodform.receivingCompany"></el-input>
        </el-form-item>
        <el-form-item  label="收货人:" prop="receivingPerson">
          <el-input  placeholder="请选择收货地址" class="disabled" maxlength="10" :readonly="true"  v-model="goodform.receivingPerson"></el-input>
        </el-form-item>
        <el-form-item label="收货人电话:" prop="receivingPhone">
          <el-input  placeholder="请选择收货地址" class="disabled" maxlength="11" :readonly="true"  type="tel" v-model="goodform.receivingPhone"></el-input>
        </el-form-item>
          <el-form-item  label="收货地址:" prop="receivingAddress" class="diqu1">
          <el-input  placeholder="请选择收货地址" class="disabled" maxlength="11" :readonly="true"  v-model="goodform.receivingAddress"></el-input>
        </el-form-item>
        <el-form-item >
              <el-button type="text"  @click="addxzdzFn(1)"><i class="fa fa-address-book-o iconFont" aria-hidden="true"></i>使用收货地址簿</el-button>
          </el-form-item>
        </div>
      </div>
       <hr>
      <div class="addressBox">
         <h4 class="title">
          <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>承运信息</span>
        </h4>
        <div>
           <el-form-item label="运单状态:" prop="orderStatus" class="ziti" >
            <template >
              <el-radio-group v-model="goodform.orderStatus" @change="orderStatusFn">
                <el-radio :label="1203" >已完成</el-radio>
                <el-radio :label="1202">运输中</el-radio>
              </el-radio-group>
            </template>
          </el-form-item>

           <div>
             <el-form-item label="承运司机:" prop="carriageName">
                <el-input   class="disabled" maxlength="20" :readonly="true"  v-model="goodform.carriageName"></el-input>
             </el-form-item>
             <el-form-item label="身份证号:" prop="carriageCustomerTaxId">
                <el-input   class="disabled" maxlength="20" :readonly="true"  v-model="goodform.carriageCustomerTaxId"></el-input>
             </el-form-item>
              <el-form-item label="车牌号:" prop="vhcNo">
                <el-input   class="disabled" maxlength="20" :readonly="true"  v-model="goodform.vhcNo"></el-input>
             </el-form-item>
              <el-form-item >
                <el-button type="primary"     @click="zhipaiFn(4)">指派</el-button>
              </el-form-item>
           </div>
        </div>
      </div>
      <hr>
      <div class="addressBox">
         <h4 class="title">
          <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>装车信息</span>
        </h4>
        <div>
            <el-form-item label="货物类型:" class="jiage" prop="productType">
              <el-select  v-model="goodform.productType"  value-key="productId"  placeholder="请选择">
                <el-option v-for="item in productTypes" :label="item.name" :value="item" :key="item.productId"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="装车量:"  prop="weight" class="danweiBox">
              <el-input  placeholder="" v-number-input.float="3"   maxlength="8"  v-model="goodform.weight" key="1" v-if="goodform.unitMeasurement!='件'"></el-input>
              <el-input  placeholder="" v-number-input.float="0"   maxlength="8"  v-model="goodform.weight" key="2" v-if="goodform.unitMeasurement=='件'"></el-input>
              <el-select  v-model="goodform.unitMeasurement"  placeholder="请选择"  @change="danweiChange">
                <el-option v-for="val in danwei" :label="val.name" :value="val.val" :key="val.val"></el-option>
                <!-- <el-option label="区域二" value="beijing"></el-option> -->
              </el-select>
            </el-form-item>
            <el-form-item label="估值:" class="jiage" prop="valuation" v-if="goodform.unitMeasurement!='吨'">
              <el-input  placeholder=""  v-number-input.float="2"   maxlength="8" v-model="goodform.valuation"  ></el-input><span class="danwei">吨</span>
            </el-form-item>
            <el-form-item label="接单时间:" prop="receivingTime" >
                  <el-date-picker
                    v-model="goodform.receivingTime"
                    type="datetime"
                    value-format="timestamp"
                    default-time="18:00:00"
                      placeholder="选择日期时间"
                      :picker-options="pickerOptions"
                      @change="receivingTimeFn"
                  ></el-date-picker>
            </el-form-item>
            <el-form-item label="装车时间:" prop="outTime" v-if="goodform.receivingTime" >
                  <el-date-picker
                    v-model="goodform.outTime"
                    type="datetime"
                    value-format="timestamp"
                      placeholder="选择日期时间"
                      :picker-options="pickerOptions1"
                      @change="outTimeFn"
                  ></el-date-picker>
            </el-form-item>
            <el-form-item label="支付对象:" prop="waybillMode " class="ziti">
              <template >
                <el-radio-group v-model="goodform.waybillMode">
                  <el-radio :label="1" >个人</el-radio>
                  <el-radio :label="2">车队长</el-radio>
                </el-radio-group>
              </template>
            </el-form-item>
            <el-form-item  v-if="goodform.waybillMode==2">
              <el-button type="primary"     @click="zhipaiFn(5)">选择车队长</el-button>
            </el-form-item>
             <el-form-item label="车队长名称:" prop="captainName" v-if="goodform.captainName">
                <el-input   class="disabled" maxlength="20" :readonly="true"  v-model="goodform.captainName"></el-input>
             </el-form-item>
        </div>
        <div>
           <el-form-item label="计价方式 :" prop="pricingMethod" class="jiage">
              <el-select  v-model="goodform.pricingMethod"  placeholder="请选择" >
                <el-option v-for="val in jjfangshi" :label="val.name" :value="val.val" :key="val.val"></el-option>
                <!-- <el-option label="区域二" value="beijing"></el-option> -->
              </el-select>
            </el-form-item>
            <el-form-item label="不含税单价:" class="jiage" prop="unitPrice" v-if="goodform.pricingMethod==''||goodform.pricingMethod==2?false:true">
              <el-input  placeholder=""  v-number-input.float="2"   maxlength="8" v-model="goodform.unitPrice"  ></el-input><span class="danwei">元/{{goodform.unitMeasurement}}</span>
            </el-form-item>
            <el-form-item label="包干价:" class="jiage" prop="unitPrice" v-if="goodform.pricingMethod==''||goodform.pricingMethod==1?false:true">
              <el-input  placeholder=""  v-number-input.float="2"  maxlength="8" v-model="goodform.unitPrice" ></el-input><span class="danwei">元</span>
            </el-form-item>
            <el-form-item label="服务费:" class="jiage" prop="taxation">
              <span>{{goodform.taxation|numFormat(2)}}</span>元
            </el-form-item>
            <el-form-item label="服务费率:"  prop="rate">
              <span class="danwei">{{goodform.rate*100}}%</span>
            </el-form-item>
            <el-form-item label="" class="mar10">
              合计费用:<span class="red">{{goodform.allP|numFormat(2)}}</span>元
            </el-form-item>
            <el-form-item label="" class="mar10">
              <span class="red">（注：合计费用=运费+服务费）</span>
            </el-form-item>
        </div>
        <uploadImgs :imgData="LimgData" @change="LimgChange" @remove="LimgRemove"></uploadImgs>
      </div>

      <hr>
      <div class="addressBox" v-if="goodform.orderStatus==1203">
        <h4 class="title">
          <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>卸车信息</span>
        </h4>
        <div>
       <el-form-item label="卸车量:"  prop="unloadingWeight" class="danweiBox">
          <el-input  placeholder="" v-number-input.float="3"   maxlength="8"  v-model="goodform.unloadingWeight" key="1" v-if="goodform.unitMeasurement!='件'"></el-input>
          <el-input  placeholder="" v-number-input.float="0"   maxlength="8"  v-model="goodform.unloadingWeight" key="2" v-if="goodform.unitMeasurement=='件'"></el-input>
          <el-select  v-model="goodform.unitMeasurement"  placeholder="请选择"  @change="danweiChange">
            <el-option v-for="val in danwei" :label="val.name" :value="val.val" :key="val.val"></el-option>
            <!-- <el-option label="区域二" value="beijing"></el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item label="卸车时间:" prop="arrivalTime" v-if="goodform.outTime">
                  <el-date-picker
                    v-model="goodform.arrivalTime"
                    value-format="timestamp"
                    type="datetime"
                      placeholder="选择日期时间"
                      :picker-options="pickerOptions2"
                       @change="arrivalTimeFn"
                  ></el-date-picker>
            </el-form-item>
        <uploadImgs :imgData="UimgData" @change="UimgChange" @remove="UimgRemove"></uploadImgs>
        </div>
      </div>
      <hr>
      <div class="addressBox">
        <h4 class="title">
          <span><i class="fa fa-bookmark-o iconFont" aria-hidden="true"></i>其他信息</span>
        </h4>
        <div>
          <div>

              <el-form-item label="已购货险:" prop="isInsurance" class="ziti"  >
              <template >
                <el-radio-group v-model="goodform.isInsurance">
                  <el-radio :label="1" >是</el-radio>
                  <el-radio :label="2">否</el-radio>
                </el-radio-group>
              </template>
            </el-form-item>
            <div style="display: inline-block;" v-if="goodform.isInsurance==1">
              <el-form-item label="保险信息:" prop="insuranceInfo"   >
                <el-input  placeholder=""    maxlength="50" v-model="goodform.insuranceInfo"  ></el-input>
              </el-form-item>
              <el-form-item label="保险单号:" prop="insuranceNo" >
                <el-input  placeholder=""    maxlength="30" v-model="goodform.insuranceNo"  ></el-input>
              </el-form-item>
              <el-form-item label="保险公司名称:" prop="insuranceCompany" >
                <el-input  placeholder=""   maxlength="20"  v-model="goodform.insuranceCompany"  ></el-input>
              </el-form-item>
            </div>
          </div>
      <el-form-item label="备注:" class="remark" prop="remark" >
        <el-input  placeholder=""  maxlength="500" v-model="goodform.remarkG"></el-input>
      </el-form-item>
      <uploadImgs :imgData="GimgData" @change="GimgChange" @remove="GimgRemove"></uploadImgs>
      </div>
      </div>
   </el-form>
   <div class="footerBtn">
      <el-button type="primary" class="bigBtn"  @click="saveFn('goodform')">提交</el-button>
    </div>
    <!-- 选择地址 -->
       <selectAddress :type= "addressType"  v-if="dialogXzdz"  @handleCurrentChange="handleCurrentChange" @destroy="destroy"></selectAddress>
    <!-- 指派组件 -->
      <assign :assignType='assignType'   v-if="assignFalg" @selectCar="selectCar" @selectFleet="selectFleet" @destroy="destroy"></assign>
  </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { dropDownList } from '@/api/soc-stock'
import { findSMPRate, supplementOrder } from '@/api/soc-customer'
import { QRcodeCDZInfo } from '@/api/vgs-match'
import assign from '@/components/networkFreight/assign.vue'
import selectAddress from '@/components/networkFreight/selectAddress.vue'
import store from '@/store'
import uploadImgs from '@/components/uploadImgs2.vue'
import { compressImage } from '@/utils/compressImage'
import { toFixed } from '@/utils/util'
export default {
  components: {
    assign,
    selectAddress,
    uploadImgs
  },
  data () {
    let token = store.getUser().access_token
    return {
      toFixed: toFixed,
      assignType: 4,
      GimgData: {
        max: 5,
        imgList: []
      },
      UimgData: {
        max: 4,
        imgList: []
      },
      LimgData: {
        max: 4,
        imgList: []
      },
      assignFalg: false,
      header: { Authorization: 'Bearer ' + token },
      dialogVisible: false,
      isAdd: false,
      freight: 0.00,
      productTypes: [
      ],
      jjfangshi: [
        { val: 1, name: '单价' },
        { val: 2, name: '包干' }
      ],
      danwei: [
        { val: '吨', name: '吨' },
        { val: '件', name: '件' },
        { val: '方', name: '方' }
      ],
      jsfangshi: [
        { val: 1, name: '电汇' },
        { val: 2, name: '现金' },
        { val: 3, name: '其他' }
      ],
      dialogAddress: false,
      types: [
        { name: '收货地址', id: 1 },
        { name: '发货地址', id: 2 }
      ],
      addFrom: {},
      rules: {
        type: [
          { required: true, message: '请选择地址类型', trigger: 'blur' }
        ],
        areaCode: [
          { required: true, message: '请选择省市县', trigger: 'blur' }
        ],
        productType: [
          { required: true, message: '请选择货物类型', trigger: 'blur' }
        ],
        weight: [
          { required: true, message: '请输入货源量', trigger: 'blur' },
          this.rule.weight
        ],
        unitPrice: [
          { required: true, message: '请输入单价或包干价', trigger: 'blur' },
          this.rule.price
        ],
        pricingMethod: [
          { required: true, message: '请选择计价方式', trigger: 'blur' }
        ],
        hopeReceivingDate: [
          { required: true, message: '请选择最晚到场日期', trigger: 'blur' }
        ],
        isInsurance: [
          { required: true, message: '是否已购货险', trigger: 'blur' }
        ],
        insuranceInfo: [
          { required: true, message: '请输入保险信息', trigger: 'blur' }
        ],
        insuranceNo: [
          { required: true, message: '请输入保险单号', trigger: 'blur' }
        ],
        insuranceCompany: [
          { required: true, message: '请输入保险公司名称', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ],
        receivingCompany: [
          { required: true, message: '请选择收货地址', trigger: 'blur' }
        ],
        receivingPerson: [
          { required: true, message: '请选择收货地址', trigger: 'blur' }
        ],
        receivingPhone: [
          { required: true, message: '请选择收货地址', trigger: 'blur' }
          // { pattern: /^[1]([3-9])[0-9]{9}$/, message: '请输入正确得电话号码' }
        ],
        deliverAddress: [
          { required: true, message: '请选择发货地址', trigger: 'blur' }
        ],
        receivingAddress: [
          { required: true, message: '请选择收货地址', trigger: 'blur' }
        ],
        deliverCompany: [
          { required: true, message: '请选择发货地址', trigger: 'blur' }
        ],
        deliverPerson: [
          { required: true, message: '请选择发货地址', trigger: 'blur' }
        ],
        deliverPhone: [
          { required: true, message: '请选择发货地址', trigger: 'blur' }
        ],
        valuation: [
          { required: true, message: '请输入估值', trigger: 'blur' }
        ],
        receivingTime: [
          { required: true, message: '请选择接单时间', trigger: 'blur' }
        ],
        outTime: [
          { required: true, message: '请选择装车时间', trigger: 'blur' }
        ],
        waybillMode: [
          { required: true, message: '请选择支付对象', trigger: 'blur' }
        ],
        unloadingWeight: [
          { required: true, message: '请输入卸车量', trigger: 'blur' }
        ],
        arrivalTime: [
          { required: true, message: '请选择卸车时间', trigger: 'blur' }
        ]
      },
      dialogXzdz: false,
      addressType: 1,
      goodform: {
        productVolume: 0,
        fatePrice: 0,
        storagePrice: '',
        weight: '',
        price: '',
        pricingMethod: '',
        taxation: 0,
        allP: 0,
        unitMeasurement: '吨',
        commissionPlatform: 1,
        scanLoading: 2,
        isInsurance: 2,
        orderStatus: 1203,
        waybillMode: 1
      },
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() || time.getTime() < Date.now() - 2 * 8.64e7
        },
        selectableRange: ['00:00:00-23:59:59', '00:00:00-9:00:00']
      },
      pickerOptions1: {
        disabledDate: tiem => {
          return tiem.getTime() > Date.now() || tiem.getTime() < this.getYMD(this.goodform.receivingTime)
        }
      },
      pickerOptions2: {
        disabledDate: tiem => {
          return tiem.getTime() < this.getYMD(this.goodform.outTime) || tiem.getTime() > Date.now()
        }
      },
      loading: null,
      flag: [false, false, false],
      btnFlg: [],
      btnIdArr: ['004P001B000', '004P001B001']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/releaseGoods')
    dropDownList().then(res => {
      this.productTypes = res
    })
    const loading = this.$loading({
      lock: true,
      text: '正在加载...'
    })
    let that = this
    findSMPRate().then(res => {
      loading.close()
      this.$set(this.goodform, 'rate', res.taxRate)
      // eslint-disable-next-line handle-callback-err
    }).catch(error => {
      findSMPRate().then(res => {
        this.$set(this.goodform, 'rate', res.taxRate)
        // eslint-disable-next-line handle-callback-err
      }).catch(error => {
        findSMPRate().then(res => {
          this.$set(this.goodform, 'rate', res.taxRate)
          // eslint-disable-next-line handle-callback-err
        }).catch(error => {
          this.$message({
            showClose: true,
            message: '补单货源功能暂不可用，请稍后再试',
            type: 'error',
            onClose () {
              loading.close()
              that.$router.push({ name: 'orderManage' })
            }
          })
        })
      })
    })
  },
  watch: {
    goodform: {
      handler (newName, oldName) {
        if (this.goodform.pricingMethod == 1) {
          if (this.goodform.weight && this.goodform.unitPrice) {
            this.goodform.fatePrice = accMul(this.goodform.weight, this.goodform.unitPrice)
            this.goodform.taxation = accMul(this.goodform.rate, this.goodform.fatePrice)
            this.$set(this.goodform, 'allP', Number(this.toFixed(this.goodform.fatePrice, 2)) + Number(this.toFixed(this.goodform.taxation, 2)))
          } else {
            this.$set(this.goodform, 'fatePrice', 0)
          }
        } else if (this.goodform.pricingMethod == 2) {
          if (this.goodform.unitPrice) {
            this.goodform.fatePrice = this.goodform.unitPrice
            this.goodform.taxation = accMul(this.goodform.rate, this.goodform.fatePrice)
            this.$set(this.goodform, 'allP', Number(this.toFixed(this.goodform.fatePrice, 2)) + Number(this.toFixed(this.goodform.taxation, 2)))
          }
        }

        function accMul (arg1, arg2) {
          var m = 0; var s1 = arg1.toString(); var s2 = arg2.toString()
          try {
            m += s1.split('.')[1].length
          } catch (e) {
          }
          try {
            m += s2.split('.')[1].length
          } catch (e) {
          }

          return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
        }
        // 限制时间
        if (this.goodform.receivingTime) {
          if (isToday(this.goodform.receivingTime)) {
            this.$set(this.pickerOptions, 'selectableRange', '00:00:00-9:00:00')
          } else {
            this.$set(this.pickerOptions, 'selectableRange', '00:00:00-23:59:59')
          }
          // 限制装车时间
          if (this.goodform.outTime) {
            if (isToday(this.goodform.receivingTime)) {
              console.log(getHMS(this.goodform.receivingTime))
              this.$set(this.pickerOptions1, 'selectableRange', getHMS(this.goodform.receivingTime) + '-9:00:00')
            } else {
              if (isToday(this.goodform.outTime)) {
                this.$set(this.pickerOptions1, 'selectableRange', '00:00:00-9:00:00')
              } else {
                this.$set(this.pickerOptions1, 'selectableRange', getHMS(this.goodform.receivingTime) + '-23:59:59')
              }
            }
          }
          // 限制卸车时间
          if (this.goodform.arrivalTime) {
            if (isToday(this.goodform.outTime) == isToday(this.goodform.arrivalTime)) {
              this.$set(this.pickerOptions2, 'selectableRange', getHMS(this.goodform.outTime) + '-23:59:59')
            } else {
              this.$set(this.pickerOptions2, 'selectableRange', '00:00:00-23:59:59')
            }
          }
        }

        function isToday (str) {
          if (new Date(str).toDateString() === new Date().toDateString()) {
            return true
          } else if (new Date(str) < new Date()) {
            return false
          }
        }
        function getHMS (time) {
          var date = new Date(time)
          var h = date.getHours()
          let m = date.getMinutes()
          let s = date.getSeconds()
          return h + ':' + m + ':' + s
        }
      },
      deep: true
      // immediate: true
    }
  },
  methods: {
    // 运输状态切换
    orderStatusFn () {
      if (this.goodform.orderStatus == 1202) {
        this.$set(this.goodform, 'unloadingWeight', '')
        this.$set(this.goodform, 'arrivalTime', '')
        this.UimgData.imgList = []
      }
    },
    GimgChange (imgList) {
      this.GimgData.imgList = imgList
    },
    GimgRemove (imgList) {
      this.GimgData.imgList = imgList
    },
    UimgChange (imgList) {
      this.UimgData.imgList = imgList
    },
    UimgRemove (imgList) {
      console.log(imgList)
      this.UimgData.imgList = imgList
    },
    LimgChange (imgList) {
      this.LimgData.imgList = imgList
    },
    LimgRemove (imgList) {
      this.LimgData.imgList = imgList
    },
    // 指派
    zhipaiFn (n) {
      this.assignType = n
      this.assignFalg = true
    },
    selectFleet (row) {
      if (this.assignType == 4) {
        for (var item in row) {
          if (item == 'fleetId') {
            this.$set(this.goodform, 'carriageCode', row[item])
          } else if (item == 'CustomerTaxId') {
            this.$set(this.goodform, 'carriageCustomerTaxId', row[item])
          } else if (item == 'fleetName') {
            this.$set(this.goodform, 'carriageName', row[item])
          } else if (item == 'mobile') {
            this.$set(this.goodform, 'carriageTelephone', row[item])
          } else {
            this.$set(this.goodform, item, row[item])
          }
        }
        this.$set(this.goodform, 'vhcId', '')
        this.$set(this.goodform, 'vhcNo', '')
        this.$set(this.goodform, 'vhcNoColor', '')
        this.$set(this.goodform, 'businessLicenseNo', '')
      } else if (this.assignType == 5) {
        this.$set(this.goodform, 'captainId', row.fleetId)
        this.$set(this.goodform, 'captainName', row.fleetName)
        this.$set(this.goodform, 'idNumCaptain', row.CustomerTaxId)
        QRcodeCDZInfo({ userId: row.fleetId }).then(res => {
          this.$set(this.goodform, 'platformAccount', res.loginUser)
        })
      }

      this.assignFalg = false
    },
    selectCar (row) {
      for (var item in row) {
        if (item == 'driverId') {
          this.$set(this.goodform, 'carriageCode', row[item])
        } else if (item == 'identityNo') {
          this.$set(this.goodform, 'carriageCustomerTaxId', row[item])
        } else if (item == 'driverName') {
          this.$set(this.goodform, 'carriageName', row[item])
        } else if (item == 'mobile') {
          this.$set(this.goodform, 'carriageTelephone', row[item])
        } else {
          this.$set(this.goodform, item, row[item])
        }
      }
      this.assignFalg = false
    },
    destroy () {
      this.assignFalg = false
      this.dialogXzdz = false
    },
    // 单位切换
    danweiChange () {
      this.$set(this.goodform, 'weight', '')
      this.$set(this.goodform, 'unloadingWeight', '')
      this.$set(this.goodform, 'valuation', '')
    },
    saveFn (formName) {
      let imgfile = new FormData()
      var that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.goodform.carriageName) {
            if (this.goodform.productType) {
              this.goodform.productTypeId = this.goodform.productType.productId
              this.goodform.productTypeName = this.goodform.productType.name
              this.goodform.productTypeCode = this.goodform.productType.productTypeCode
            }
            if (this.goodform.isInsurance == 2) {
              this.goodform.insuranceInfo = ''
              this.goodform.insuranceNo = ''
              this.goodform.insuranceCompany = ''
            }
            if (!this.goodform.captainId && this.goodform.waybillMode == 2) {
              this.$alert('请选择车队长', '系统提示')
            } else if (this.LimgData.imgList.length == 0) {
              this.$alert('请选择装车凭证', '系统提示')
            } else if (this.UimgData.imgList.length == 0 && this.goodform.orderStatus == 1203) {
              this.$alert('请选择卸车凭证', '系统提示')
            } else {
              this.loading = that.$loading({
                lock: true,
                text: '正在处理...'
              })
              imgfile.append('params', JSON.stringify(this.goodform))
              // 货物图片压缩
              if (this.GimgData.imgList.length > 0) {
                this.GimgData.imgList.forEach((item, i) => {
                  let a = i
                  compressImage(item.url, item.raw, {
                    width: 1000
                  }).then(result => {
                    imgfile.append('files', result)
                    if (a == that.GimgData.imgList.length - 1) {
                      that.flag[0] = true
                      if (that.flag[0] && that.flag[1] && that.flag[2]) {
                        saveFN()
                      }
                    }
                  })
                })
              } else {
                that.flag[0] = true
              }
              // 装车图片压缩
              this.LimgData.imgList.forEach((item, i) => {
                let a = i
                compressImage(item.url, item.raw, {
                  width: 1000
                }).then(result => {
                  console.log(result)
                  imgfile.append('loadFiles', result)
                  if (a == that.LimgData.imgList.length - 1) {
                    that.flag[1] = true
                    if (that.flag[0] && that.flag[1] && that.flag[2]) {
                      saveFN()
                    }
                  }
                })
              })
              // 卸车图片压缩
              if (this.UimgData.imgList.length > 0) {
                this.UimgData.imgList.forEach((item, i) => {
                  let a = i
                  compressImage(item.url, item.raw, {
                    width: 1000
                  }).then(result => {
                    imgfile.append('unLoadFiles', result)
                    if (a == that.UimgData.imgList.length - 1) {
                      that.flag[2] = true
                      if (that.flag[0] && that.flag[1] && that.flag[2]) {
                        saveFN()
                      }
                    }
                  })
                })
              } else {
                that.flag[2] = true
              }
            }
          } else {
            this.$alert('请指派承运方', '系统提示')
          }
        }
      })

      function saveFN () {
        supplementOrder(imgfile).then(res => {
          that.loading.close()
          that.$router.push({ name: 'orderManage' })
        }).catch(error => {
          that.flag = [false, false, false]
          that.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              that.loading.close()
            }
          })
        })
      }
    },
    // 选择地址
    addxzdzFn (n) {
      this.addressType = n
      this.dialogXzdz = true
    },
    handleCurrentChange (val) {
      this.currentRow = val
      this.dialogXzdz = false
      if (this.addressType == 1) {
        this.$set(this.goodform, 'receivingCompany', this.currentRow.company)
        this.$set(this.goodform, 'receivingPerson', this.currentRow.person)
        this.$set(this.goodform, 'receivingPhone', this.currentRow.phone)
        this.$set(this.goodform, 'receivingAddress', this.currentRow.name)
        this.goodform.receivingProvinceCode = this.currentRow.provinceCode
        this.goodform.receivingCityCode = this.currentRow.cityCode
        this.goodform.receivingAreaCode = this.currentRow.areaCode
        this.goodform.receivingProvinceName = this.currentRow.provinceName
        this.goodform.receivingCityName = this.currentRow.cityName
        this.goodform.receivingAreaName = this.currentRow.areaName
        this.goodform.receivingAddressId = this.currentRow.id
        this.goodform.receivingLongitude = this.currentRow.longitude
        this.goodform.receivingLatitude = this.currentRow.latitude
      } else {
        this.$set(this.goodform, 'deliverCompany', this.currentRow.company)
        this.$set(this.goodform, 'deliverPerson', this.currentRow.person)
        this.$set(this.goodform, 'deliverPhone', this.currentRow.phone)
        this.$set(this.goodform, 'deliverAddress', this.currentRow.name)
        this.goodform.deliverProvinceCode = this.currentRow.provinceCode
        this.goodform.deliverCityCode = this.currentRow.cityCode
        this.goodform.deliverAreaCode = this.currentRow.areaCode
        this.goodform.deliverProvinceName = this.currentRow.provinceName
        this.goodform.deliverCityName = this.currentRow.cityName
        this.goodform.deliverAreaName = this.currentRow.areaName
        this.goodform.deliverAddressId = this.currentRow.id
        this.goodform.deliverLongitude = this.currentRow.longitude
        this.goodform.deliverLatitude = this.currentRow.latitude
      }
      this.$refs.goodform.clearValidate()
    },
    // 时间判断
    receivingTimeFn () {
      let h24 = 24 * 60 * 60 * 1000
      let h9 = 9 * 60 * 60 * 1000
      let min = fun30() - h24
      let max = fun30() + h9
      if (this.goodform.receivingTime < min || this.goodform.receivingTime > max) {
        this.$alert('请选择昨天到今天早上9点的时间', '系统提示')
        this.$set(this.goodform, 'receivingTime', null)
      }
      this.$set(this.goodform, 'outTime', null)
      this.$set(this.goodform, 'arrivalTime', null)
      function fun30 () { // 获取今天0点时间戳
        let today = new Date()
        today.setHours(0, 0, 0, 0)
        return today.getTime()
      }
    },
    outTimeFn () {
      let h9 = 9 * 60 * 60 * 1000
      let max = fun30() + h9
      if (this.goodform.receivingTime >= this.goodform.outTime || max < this.goodform.outTime) {
        this.$alert('装车时间需要大于接单时间,且不能大于今天早上9点', '系统提示')
        this.$set(this.goodform, 'outTime', null)
      }
      this.$set(this.goodform, 'arrivalTime', null)
      function fun30 () { // 获取今天0点时间戳
        let today = new Date()
        today.setHours(0, 0, 0, 0)
        return today.getTime()
      }
    },
    arrivalTimeFn () {
      let max = new Date().getTime()
      if (this.goodform.outTime >= this.goodform.arrivalTime || max <= this.goodform.arrivalTime) {
        this.$alert('卸车时间需要大于装车时间,且不能大于当前时间', '系统提示')
        this.$set(this.goodform, 'arrivalTime', null)
      }
    },
    back () {
      this.$router.go(-1)// 返回上一层
    },
    getYMD (time) {
      var date = new Date(time)
      let Y = date.getFullYear()
      let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      let D = date.getDate()
      let timer = new Date(Y + '-' + M + '-' + D + ' 00:00:00').getTime()
      return timer
    }

  }
}
</script>

<style scoped lang='less'>

.danweiBox{
  /deep/.el-input{
    width: auto;
  }
  /deep/.el-select{
    width: 60px;
    .el-input__inner{
    width: 60px;
  }
  }
}

</style>
